import { render, staticRenderFns } from "./GuiaCorte.vue?vue&type=template&id=861dd40a&scoped=true&"
import script from "./GuiaCorte.vue?vue&type=script&lang=js&"
export * from "./GuiaCorte.vue?vue&type=script&lang=js&"
import style0 from "./GuiaCorte.vue?vue&type=style&index=0&id=861dd40a&prod&lang=scss&scoped=true&"
import style1 from "./GuiaCorte.vue?vue&type=style&index=1&id=861dd40a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "861dd40a",
  null
  
)

export default component.exports